import { useMediaQuery } from '@mantine/hooks';

/**
 * A phone held sideways: wide enough for two columns but too short for a
 * layout with a bar fixed to the bottom. Evaluated on the first render, like
 * useIsMobile.
 */
export function useIsLandscapePhone(): boolean {
  return (
    useMediaQuery('(orientation: landscape) and (max-height: 500px)', false, {
      getInitialValueInEffect: false,
    }) ?? false
  );
}
